/*!
 * Copyright 2025 - Swiss Data Science Center (SDSC)
 * A partnership between École Polytechnique Fédérale de Lausanne (EPFL) and
 * Eidgenössische Technische Hochschule Zürich (ETHZ).
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import cx from "classnames";
import { Alert } from "reactstrap";

interface TakeActionAlertProps {
  children: React.ReactNode;
  "data-cy"?: string;
  icon?: React.ReactNode;
  className?: string;
}
export default function TakeActionAlert({
  children,
  icon,
  ...props
}: TakeActionAlertProps) {
  return (
    <Alert
      color="take-action"
      isOpen
      data-cy={props["data-cy"]}
      className={cx(props.className, "overflow-y-auto")}
    >
      <div className={cx("d-flex", "gap-3")}>
        {icon && <div>{icon}</div>}
        <div className={cx("my-auto", "w-100")}>{children}</div>
      </div>
    </Alert>
  );
}
